





























































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ThirdPartyTransaction from '@/models/Accounts/ThirdPartyAccounts/ThirdPartyTransaction';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import DebitCreditCode from '@/models/Shared/DebitCreditCode';

@Component({ name: 'ThirdPartyAccountTransactionDetailsDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    dialog = false;
    DebitCreditCode = DebitCreditCode;

    @Prop({required: true})
    transaction: ThirdPartyTransaction;

}
